/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteGeneticsReport200Response
 */
export interface DeleteGeneticsReport200Response {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteGeneticsReport200Response
     */
    success?: boolean;
}

/**
 * Check if a given object implements the DeleteGeneticsReport200Response interface.
 */
export function instanceOfDeleteGeneticsReport200Response(value: object): value is DeleteGeneticsReport200Response {
    return true;
}

export function DeleteGeneticsReport200ResponseFromJSON(json: any): DeleteGeneticsReport200Response {
    return DeleteGeneticsReport200ResponseFromJSONTyped(json, false);
}

export function DeleteGeneticsReport200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteGeneticsReport200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
    };
}

export function DeleteGeneticsReport200ResponseToJSON(json: any): DeleteGeneticsReport200Response {
    return DeleteGeneticsReport200ResponseToJSONTyped(json, false);
}

export function DeleteGeneticsReport200ResponseToJSONTyped(value?: DeleteGeneticsReport200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
    };
}

